import { render, staticRenderFns } from "./KorrupsiyaXabar.vue?vue&type=template&id=6e02312c&scoped=true&"
import script from "./KorrupsiyaXabar.vue?vue&type=script&lang=js&"
export * from "./KorrupsiyaXabar.vue?vue&type=script&lang=js&"
import style0 from "./KorrupsiyaXabar.vue?vue&type=style&index=0&id=6e02312c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e02312c",
  null
  
)

export default component.exports